"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const notifySessionExpired_1 = __importDefault(require("../actions/signin/notifySessionExpired"));
const authClient_1 = require("../utils/authClient");
const errorHandlingMiddleware = store => next => event => {
    if ("httpError" in event && event.httpError) {
        const httpError = event.httpError;
        if (httpError.code === 401
            || httpError.code === 403
            || authClient_1.getTimeUntilSessionExpiryMs() <= 0) {
            return store.dispatch(notifySessionExpired_1.default());
        }
    }
    return next(event);
};
exports.default = errorHandlingMiddleware;
